import { SMSMessageDto } from '@act/shared/data-transfer-objects';
import { CardContent, Dialog } from '@mui/material';
import { TrackingProvider } from 'react-components/tracking';

import { GenericDialogProps } from 'utilities/dialog-context/DialogContextHelpers';
import {
  DialogContentContainer,
  DialogTitleBarComponent,
} from '../dialog-forms/components/SharedDialogHookComponents';
import useUnsavedChangesDialog from '../dialog-forms/hooks/useUnsavedChangesDialog.hook';
import { AssignPhoneNumberFormComponent } from './AssignPhoneNumberForm';

export interface AssignPhoneNumberUniqueProps {
  phoneNumber: string;
  callId?: number;
  sms?: SMSMessageDto;
}

export type AssignPhoneNumberDialogProps =
  GenericDialogProps<AssignPhoneNumberDialogCallbackInput> &
    AssignPhoneNumberUniqueProps;

export type AssignPhoneNumberDialogCallbackInput = Record<string, never>;

const AssignPhoneNumberDialog = ({
  phoneNumber,
  callId,
  sms,
  open,
  setOpen,
}: AssignPhoneNumberDialogProps) => {
  const handleUnsavedChanges = useUnsavedChangesDialog();

  function handleClose() {
    // TODO: Track if form is dirty and show unsaved changes dialog
    void handleUnsavedChanges(() => {
      setOpen(false);
    });
  }

  function handleSuccess() {
    setOpen(false);
  }

  return (
    <TrackingProvider contextName="assign-phone-number-dialog">
      <div style={{ width: '600px' }}>
        <Dialog open={open} onClose={handleClose} fullWidth>
          <DialogContentContainer>
            <DialogTitleBarComponent
              title="Assign phone call"
              handleClose={handleClose}
            />
            <CardContent sx={{ padding: '12px 24px 0' }}>
              <AssignPhoneNumberFormComponent
                phoneNumber={phoneNumber}
                callId={callId}
                sms={sms}
                onSuccess={handleSuccess}
                onCancel={handleClose}
                showActions={true}
                showAlert={true}
                showTitle={true}
              />
            </CardContent>
          </DialogContentContainer>
        </Dialog>
      </div>
    </TrackingProvider>
  );
};

export default AssignPhoneNumberDialog;
